import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Toaster } from '@/components/ui/sonner';
import Layout from '@/components/Layout';
import AgeGate from '@/components/AgeGate';
import Home from '@/pages/Home';
import Gamme from '@/pages/Gamme';
import BeerDetail from '@/pages/BeerDetail';
import About from '@/pages/About';
import TapRental from '@/pages/TapRental';
import Professionnels from '@/pages/Professionnels';
import PointsDeVente from '@/pages/PointsDeVente';
import Contact from '@/pages/Contact';
import LegalMentions from '@/pages/LegalMentions';
import Privacy from '@/pages/Privacy';

function App() {
  const [showAgeGate, setShowAgeGate] = useState(true);

  useEffect(() => {
    const ageVerified = localStorage.getItem('age_verified');
    if (ageVerified === 'true') {
      setShowAgeGate(false);
    }
  }, []);

  const handleAgeVerified = () => {
    localStorage.setItem('age_verified', 'true');
    setShowAgeGate(false);
  };

  return (
    <div className="App grain-texture">
      {showAgeGate && <AgeGate onVerified={handleAgeVerified} />}
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nos-bieres" element={<Gamme />} />
            <Route path="/nos-bieres/:slug" element={<BeerDetail />} />
            <Route path="/professionnels" element={<Professionnels />} />
            <Route path="/points-de-vente" element={<PointsDeVente />} />
            <Route path="/location-tireuse" element={<TapRental />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/mentions-legales" element={<LegalMentions />} />
            <Route path="/confidentialite" element={<Privacy />} />
            {/* Redirections des anciennes URLs e-commerce vers la vitrine */}
            <Route path="/boutique" element={<Navigate to="/nos-bieres" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
